import { omit } from 'lodash/fp';
import { withHandlers, compose, withState, mapProps } from '../../node_module_clones/recompose';

// Utils
import { getCanvasLocationFromClientOffset } from './utils/canvasPositionUtils';
import { getCanvasOriginCoordinates } from '../../common/elements/utils/elementPropertyUtils';
import allowDoubleClickCreateShortcutDecorator from '../components/events/allowDoubleClickCreateShortcutDecorator';

// Constants
import { ELEMENT_CREATION_SOURCES } from '../../common/elements/elementConstants';

const omitProps = compose(mapProps, omit);

const shortcutElementHandlers = {
    onDoubleClick:
        ({
            canvasViewportDomElement,
            createShortcutCard,
            gridSize,
            zoomScale,
            zoomTranslationPx,
            currentBoardId,
            currentBoard,
            isEditable,
            blockTemplateInteraction,
            drawingModeEnabled,
        }) =>
        (event) => {
            if (!canvasViewportDomElement || !isEditable || blockTemplateInteraction || drawingModeEnabled) return;

            const clientPositionPx = {
                x: event.clientX,
                y: event.clientY - 1,
            };

            const canvasOrigin = getCanvasOriginCoordinates(currentBoard);

            const { location } = getCanvasLocationFromClientOffset(
                canvasViewportDomElement,
                clientPositionPx,
                gridSize,
                currentBoardId,
                canvasOrigin,
                zoomScale,
                zoomTranslationPx,
            );

            createShortcutCard({ location, creationSource: ELEMENT_CREATION_SOURCES.DOUBLE_CLICK });
        },
};

const shortcutElementDecorator = compose(
    withState('canvasViewportDomElement', 'setShortcutHandlerCanvasViewportDomElement', null),
    withHandlers(shortcutElementHandlers),
    omitProps(['canvasViewportDomElement']),
    allowDoubleClickCreateShortcutDecorator,
);

export default shortcutElementDecorator;
